export default __webpack_public_path__ + "static/media/base-report14.b9625932.png";